<template>
    <div class="container changepassword">
        <div class="content">
                <p>Skriv inn nytt passord som du ønsker å endre til</p>

            </div>

            <b-field label="Nytt passord">
                <b-input type="password" v-model="password1" password-reveal></b-input>
            </b-field>

            <b-field label="Gjenta nytt passord">
                <b-input type="password" v-model="password2" password-reveal></b-input>
            </b-field>

            <div class="content" v-if="errorMsg">
                <div class="field">
                    <span class="has-text-danger">{{ errorMsg }}</span>
                </div>
            </div>

            <b-button type="is-primary" @click="commitChanges()">Endre passord</b-button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default { 
    props: ['message', 'mode'],
    data () {
        return {
            errorMsg: undefined,
            password1: '',
            password2: ''
        }
    },
    computed: {
        ...mapGetters('auth', ['profile'])
    },
        
    methods: {
        ...mapActions('auth', ['changePassword']),
        async commitChanges () {
            try {
                if (this.password1 !== this.password2) {
                    this.errorMsg = 'Passordene samstemmer ikke. Vennligst angi like passord.'
                    return
                }
                if (this.password1.length < 8) {
                    this.errorMsg = 'Vennligst angi passord med minimum 8 tegn'
                    return
                }
                
                const userId = this.profile.user_id                
                await this.changePassword({userId: userId, password: this.password1})
                this.$router.push('/')
                
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    }
}
</script>

<style lang="scss" scoped>
div.changepassword {
    margin-top:32px;
}
</style>

